export default "/images/minivan-toyota2.jpg?e71898f8cbe10ec456add821aeab2abe";